import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const skuOptionsPLPSelector = createSelector(testTargetOffersSelector, offers => offers.showSkuOptionsPLP || Empty.Object);

export { skuOptionsPLPSelector };
